import styled from 'styled-components';

const Logo = styled.img`
  width: ${({ size }) => (size === 'sm' && '28px') || '48px'};
  height: ${({ size }) => (size === 'sm' && '28px') || '48px'};
  object-fit: contain;
`;

export default Logo;
